export class TableName {
  public static CommonCode = 'CommonCode';

  public static CommonCodeMapping = 'CommonCodeMapping';
  
  public static StockMaster = 'StockMaster';

  public static DefaultLedger = 'DefaultLedger';

  public static Tenant = 'Tenant';

  public static Users = 'TenantUser';

  public static CompanyMaster ='CompanyMaster';

  public static CompanyMapping = 'CompanyMapping';
}
